import { render, staticRenderFns } from "./BaseColorPicker.vue?vue&type=template&id=83c7f1e8&scoped=true&"
import script from "./BaseColorPicker.vue?vue&type=script&lang=js&"
export * from "./BaseColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./BaseColorPicker.vue?vue&type=style&index=0&id=83c7f1e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c7f1e8",
  null
  
)

export default component.exports